module.exports = __webpack_public_path__ + "fonts/Astron-2.6a0877ba.otf";